import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import { FieldArrayPath, FieldValues } from "react-hook-form";
import { RhfControlledTableHeaderProps } from "./RhfControlledTableHeaderProps";

export const RhfControlledTableHeader = <
  TFormModel extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFormModel>
>({
  columns,
}: RhfControlledTableHeaderProps<TFormModel, TFieldArrayName>) => {
  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.fieldKey}
            align={column.isNumeric ? "right" : "left"}
            padding="normal"
            width={column.width}
          >
            {column.headerText}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
